import { render } from "./CustomMessage.vue?vue&type=template&id=aa2b52d8"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mahoro\\projects\\crane\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__